import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import styles from "../../../creditReports/reportsDetailTable/ReportsDetailTable.module.scss";
import { SearchIcon } from "customIcons";

/**
 * ReportsDetailTableSkeleton Component
 *
 * Displays a loading skeleton for the ReportsDetailTable component.
 * Shows placeholder rows while the actual data is being fetched.
 */
const ReportsDetailTableSkeleton: React.FC = () => {
  // Generate 5 skeleton rows
  const skeletonRows = Array.from({ length: 5 }, (_, index) => index);

  return (
    <div className={`${styles["reports-table"]} reports-table`}>
      {/* Action Bar */}
      <div className={styles["reports-table__action-bar"]}>
        <div className={styles["reports-table__action-bar__left"]}></div>
        <div className={styles["reports-table__action-bar__right"]}></div>
      </div>

      {/* Table Container */}
      <div className={styles["reports-table__table-wrapper"]}>
        <TableContainer>
          <Table className={styles["reports-table__table"]}>
            {/* Table Header */}
            <TableHead>
              <TableRow className={styles["reports-table__head-row"]}>
                <TableCell>Credit ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Mobile Number</TableCell>
                <TableCell>Company Name</TableCell>
                <TableCell>Value</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Credit Date/Time</TableCell>
              </TableRow>
            </TableHead>

            {/* Table Body with Skeleton Rows */}
            <TableBody>
              {skeletonRows.map((index) => (
                <TableRow
                  key={index}
                  className={styles["reports-table__body-row"]}
                  sx={{ height: "84px" }}
                >
                  {/* Credit ID Skeleton */}
                  <TableCell>
                    <Skeleton variant="text" width="80%" />
                  </TableCell>

                  {/* Name & Email Skeleton */}
                  <TableCell>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Skeleton variant="text" width="70%" />
                      <Skeleton variant="text" width="60%" />
                    </div>
                  </TableCell>

                  {/* Mobile Number Skeleton */}
                  <TableCell>
                    <Skeleton variant="text" width="80%" />
                  </TableCell>

                  {/* Company Name Skeleton */}
                  <TableCell>
                    <Skeleton variant="text" width="70%" />
                  </TableCell>

                  {/* Credit Value Skeleton */}
                  <TableCell>
                    <Skeleton variant="text" width="60%" />
                  </TableCell>

                  {/* Status Skeleton */}
                  <TableCell>
                    <Skeleton variant="text" width="70%" />
                  </TableCell>

                  {/* Date & Time Skeleton */}
                  <TableCell>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="60%" />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default ReportsDetailTableSkeleton;
